import { useContext } from 'use-context-selector';
import { AccountContext } from 'Contexts/AccountContext';

export default function useAccount() {
  return useContext(AccountContext);
}
